import { z } from 'zod';

export const cuttingSlipNumberHelper =
  'Cutting slip number is required. Please select a valid cutting slip number.';
export const cuttingSlipNumberSchema = z
  .string()
  .min(1, cuttingSlipNumberHelper);
